import React, {Fragment} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {greys} from "@irati/ui/src/global/colors"
import Tr from "../../ui/SimpleTable/Tr"
import BaseCell from "./BaseCell"

const BaseCellWithBorder = styled(BaseCell)`
  border-bottom: 1px solid ${greys.graphGrey}!important;
`

const TableSpacer = ({colSpan}) => (
  <Fragment>
    <Tr>
      <BaseCell />
      <BaseCell colSpan={colSpan} />
    </Tr>
    <Tr>
      <BaseCell />
      <BaseCellWithBorder colSpan={colSpan} />
    </Tr>
    <Tr>
      <BaseCell />
      <BaseCell colSpan={colSpan} />
    </Tr>
  </Fragment>
)

TableSpacer.propTypes = {
  colSpan: PropTypes.number.isRequired
}

export default TableSpacer
